
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"reportTemplateFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ReportTemplate"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"dataSource"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"criteria"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"field"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"operator"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"value"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"isScheduled"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"templateStructure"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"field"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"emails"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptionConfiguration"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exceptionDays"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"exceptionTime"},"arguments":[],"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"scheduleType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduleTime"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduleDayOfMonth"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduleDayOfWeek"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"scheduleTimezone"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"createdAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"lastRunAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nextRunAt"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"creatorName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"relationType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"unitsIds"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"groupsIds"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":442}};
    doc.loc.source = {"body":"fragment reportTemplateFragment on ReportTemplate {\n  id\n  name\n  dataSource\n  criteria {\n    field\n    operator\n    value\n  }\n  isScheduled\n  templateStructure {\n    name\n    field\n  }\n  emails\n  exceptionConfiguration {\n    exceptionDays\n    exceptionTime\n  }\n  scheduleType\n  scheduleTime\n  scheduleDayOfMonth\n  scheduleDayOfWeek\n  scheduleTimezone\n  createdAt\n  lastRunAt\n  nextRunAt\n  creatorName\n  relationType\n  unitsIds\n  groupsIds\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["reportTemplateFragment"] = oneQuery(doc, "reportTemplateFragment");
        
